import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebaseConfig';
import { Save, X, Trash2, Plus, UploadCloud } from 'lucide-react';

const EditForm = ({ news, onCancel }) => {
  const [hero, setHero] = useState(news);
  const [loading, setLoading] = useState(false);

  // File Removal
  const removeMedia = (type, index) => {
    setHero(prev => ({
      ...prev,
      [type]: prev[type].filter((_, i) => i !== index)
    }));
  };

  // Add Empty Field for new Upload
  const addMediaField = (type) => {
    setHero(prev => ({
      ...prev,
      [type]: [...(prev[type] || []), '']
    }));
  };

  // Handle New File Upload
  const handleFileUpload = async (e, index, type) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", "apurdu-news");
    const url = `https://api.cloudinary.com/v1_1/dddxltark/${type}/upload`;

    try {
      const res = await fetch(url, { method: "POST", body: formData });
      const data = await res.json();
      if (data.secure_url) {
        setHero(prev => {
          const updated = { ...prev };
          updated[type][index] = data.secure_url;
          return updated;
        });
      }
    } catch (err) { alert("Upload Failed"); }
    setLoading(false);
  };

  const handleUpdate = async () => {
    setLoading(true);
    try {
      await updateDoc(doc(db, "news", news.id), hero);
      alert("News Updated Successfully!");
      onCancel();
    } catch (err) { alert("Error: " + err.message); }
    setLoading(false);
  };

  return (
    <div className="edit-overlay">
      <div className="edit-form-card" style={{ maxWidth: '900px' }}>
        <h2>Edit News Details</h2>
        <div className="form-grid">
          <div className="input-group"><label>Urdu Title</label><input dir="rtl" value={hero.titleUr} onChange={(e) => setHero({...hero, titleUr: e.target.value})} /></div>
          <div className="input-group"><label>English Title</label><input value={hero.titleEn} onChange={(e) => setHero({...hero, titleEn: e.target.value})} /></div>
          <div className="input-group"><label>Date</label><input type="date" value={hero.date} onChange={(e) => setHero({...hero, date: e.target.value})} /></div>
        </div>

        {/* Media Management */}
        <div className="media-section" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginTop: '20px' }}>
          {/* Images */}
          <div>
            <label>Images</label>
            {(hero.images || []).map((img, i) => (
              <div key={i} className="media-row">
                <input type="file" onChange={(e) => handleFileUpload(e, i, 'image')} />
                {img && <img src={img} style={{ width: '40px', height: '40px' }} />}
                <button onClick={() => removeMedia('images', i)} className="btn-delete-small"><Trash2 size={16}/></button>
              </div>
            ))}
            <button className="add-btn" onClick={() => addMediaField('images')}><Plus size={16}/> Add Image</button>
          </div>

          {/* Videos */}
          <div>
            <label>Videos</label>
            {(hero.videos || []).map((vid, i) => (
              <div key={i} className="media-row">
                <span>{vid ? '✅ Link Added' : 'No Video'}</span>
                <button onClick={() => removeMedia('videos', i)} className="btn-delete-small"><Trash2 size={16}/></button>
              </div>
            ))}
            <button className="add-btn" onClick={() => addMediaField('videos')}><Plus size={16}/> Add Video</button>
          </div>
        </div>

        <div className="form-actions" style={{ marginTop: '30px' }}>
          <button className="btn-action btn-save" onClick={handleUpdate} disabled={loading}>{loading ? 'Saving...' : 'Update News'}</button>
          <button className="btn-action btn-delete" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};
export default EditForm;